"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Icon_1 = __importDefault(require("../Icon"));
/**
 * Primary UI component for user interaction
 * @block
 */
const Button = (_a) => {
    var { type = 'primary', size = 'md', label, children, className, classNames = [], href, icon } = _a, props = __rest(_a, ["type", "size", "label", "children", "className", "classNames", "href", "icon"]);
    const btnProps = Object.assign({ className: className || (0, classnames_1.default)('btn', `btn-${type}`, `btn-${size}`, ...classNames) }, props);
    if (!href || !btnProps.target || btnProps.target === '_self') {
        delete btnProps.target;
    }
    if (btnProps.target) {
        btnProps.rel = 'noreferrer noopener';
    }
    return href ? (react_1.default.createElement("a", Object.assign({ href: href }, btnProps),
        icon && react_1.default.createElement(Icon_1.default, { name: icon }),
        label,
        children)) : (
    // @ts-ignore
    react_1.default.createElement("button", Object.assign({ type: "button" }, btnProps),
        icon && react_1.default.createElement(Icon_1.default, { name: icon }),
        label,
        children));
};
exports.default = Button;
